import {
  ClickAwayListener,
  Fade,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Popper,
} from '@material-ui/core'
import { Button } from 'components/facets'
import { useScopelessHotkeys } from 'lib/hooks'
import { useState } from 'react'
import { SetState } from 'types'
import { ESCAPE_STRING_FOR_EMPTY_COMMENT } from 'utils/constants'

interface TextfieldPopperProps {
  anchorEl: HTMLElement
  setAnchorEl: SetState<HTMLElement | null>
  onSubmit: (value: string) => void
  name: string
  placeholder: string
  showStartAdornment?: boolean
  style?: React.CSSProperties | undefined
}

export const TextfieldPopper = ({
  anchorEl,
  setAnchorEl,
  onSubmit,
  name,
  placeholder = '',
  showStartAdornment = false,
  style,
}: TextfieldPopperProps): JSX.Element => {
  const [inputValue, setInputValue] = useState('')

  useScopelessHotkeys(
    'enter',
    () => {
      if (inputValue) onSubmit(inputValue)
    },
    [inputValue]
  )

  const handleStartAdornmentClick = () => {
    const specialValue = ESCAPE_STRING_FOR_EMPTY_COMMENT
    setInputValue(specialValue)
    onSubmit(specialValue)
  }

  const EndAdornment = (): JSX.Element => (
    <InputAdornment position="end">
      <IconButton
        disabled={!inputValue}
        color="primary"
        data-testid="bulk-edit-btn"
        onClick={() => onSubmit(inputValue)}
        edge="end"
      >
        <i className="fa-regular fa-arrow-turn-down-left"></i>
      </IconButton>
    </InputAdornment>
  )

  const StartAdornment = (): JSX.Element => (
    <InputAdornment position="end">
      <Button
        variant="outlined"
        data-testid="bulk-edit-start-btn"
        onClick={handleStartAdornmentClick}
        style={{
          fontSize: '10px',
          width: '120px',
          marginRight: '10px',
          backgroundColor: 'white',
        }}
      >
        {'Remove comment'}
      </Button>
    </InputAdornment>
  )

  return (
    <ClickAwayListener
      onClickAway={() => {
        setInputValue('')
        setAnchorEl(null)
      }}
    >
      <Popper open={!!anchorEl} anchorEl={anchorEl} transition style={style}>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div className="custom-textfieldPopper">
              <OutlinedInput
                autoFocus
                autoComplete="off"
                name={name}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onFocus={(event) => event.target.select()}
                placeholder={placeholder}
                endAdornment={<EndAdornment />}
                startAdornment={showStartAdornment ? <StartAdornment /> : undefined}
              />
            </div>
          </Fade>
        )}
      </Popper>
    </ClickAwayListener>
  )
}
